import React, { useEffect, useState } from "react";
import { useThrottleFn } from "ahooks";
import { useHistory, useLocation } from "react-router-dom";

import { useStores } from "@/store";

import MobileHeadBar from "./mobile";
import DesktopHeadBar from "./desktop";

import "./index.less";
import "./index-mobile.less";

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState(
    window.innerWidth < 768 ? "mobile" : "desktop"
  );
  const { run: handleResize } = useThrottleFn(
    () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType("mobile");
      } else {
        setDeviceType("desktop");
      }
    },
    { wait: 200 }
  );
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return deviceType;
};

// HeadBar 入口：只负责 Provider + 设备类型切换
const HeadBarWrapper = ({ hidden = false }) => {
  const deviceType = useDeviceType();

  const history = useHistory();
  const location = useLocation();
  const { HeaderStore } = useStores();

  useEffect(() => {
    HeaderStore.attachRouter(history);
    HeaderStore.init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    HeaderStore.syncFromLocation(location);
  }, [HeaderStore, location]);

  if (hidden) return null;
  return deviceType === "mobile" ? <MobileHeadBar /> : <DesktopHeadBar />;
};

export default HeadBarWrapper;
